import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "radio-container-pc" }
const _hoisted_2 = {
  key: 0,
  class: "validator-line"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "radio-icon" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "radio-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      ($props.validator && !$props.isDisabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($setup.TUITranslateService.t("AIDesk.请填写必填项")), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.chooseItemList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['form-radio-box-pc',$props.isDisabled ? 'form-radio-box-pc-disabled' : '']),
          key: index
        }, [
          _createElementVNode("div", {
            class: "radio-container-pc-icon",
            onClick: ($event: any) => ($setup.clickItem(index))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: $setup.changeSelectedIcon(item),
                alt: "",
                style: {"width":"20px","height":"20px","vertical-align":"middle"}
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item), 1)
          ], 8, _hoisted_3)
        ], 2))
      }), 128))
    ])
  ]))
}